import { ExperienceFieldsFragment, useExperienceEventsQuery } from '@/generated/graphql';
import EventBookingModal from './event-booking-modal';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { useMemo, useState } from 'react';
import BookingButton from './event-booking-button';

const DateMobile = styled(Typography)`
  color: #000;
  font-size: 16px;
  font-family: var(--font-work-sans);
  font-weight: 700;
  line-height: 157.3%;
`;
const TimeMobile = styled(Typography)`
  color: #000;
  font-size: 16px;
  font-family: var(--font-work-sans);
  font-weight: 400;
  line-height: 157.3%;
`;
const TimesMobile = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
`;
const MoreTimesLink = styled(Typography)`
  font-family: var(--font-work-sans);
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 159.3%;
  text-decoration-line: underline;
  color: #7a3b6e;
`;
type EventActionsProps = {
  experience: ExperienceFieldsFragment;
};
const MobileEventActions = ({ experience }: EventActionsProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const now = useMemo(() => DateTime.now().startOf('hour').toISO(), []);
  const { data, loading } = useExperienceEventsQuery({
    variables: {
      id: experience?.id,
      now,
    },
    skip: !experience?.id,
  });

  const events = data?.events?.edges || [];
  const nextEvent = events[0] ? events[0].node : null;
  const hasMoreEvents = events.length > 1;

  if (!nextEvent) {
    return null;
  }

  if (loading || !experience?.id || !events || !events.length) {
    return null;
  }
  return (
    <>
      <TimesMobile>
        <DateMobile>
          {DateTime.fromISO(nextEvent.start).toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
          })}
        </DateMobile>
        <TimeMobile>
          {DateTime.fromISO(nextEvent.start).toLocaleString(DateTime.TIME_SIMPLE)} -{' '}
          {DateTime.fromISO(nextEvent.end).toLocaleString(DateTime.TIME_SIMPLE)}{' '}
          {DateTime.fromISO(nextEvent.end).toFormat('ZZZZ')}
        </TimeMobile>
        {hasMoreEvents && (
          <MoreTimesLink onClick={() => setModalOpen(true)}>More Times</MoreTimesLink>
        )}
      </TimesMobile>
      <BookingButton event={nextEvent} experience={experience} />
      <EventBookingModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        events={events.map(edge => edge.node)}
        capacityLimitDefined={false}
      />
    </>
  );
};

export default MobileEventActions;
